import { Box, Stack, StackProps, Typography, TypographyProps } from '@mui/material';
import { ReactNode } from 'react';

interface Props extends StackProps {
  label?: ReactNode;
  value?: ReactNode;
  variant?: TypographyProps['variant'];
}

export default function InfoItem({ label, value, direction = 'row', variant = 'h5', ...props }: Props) {
  return (
    <Stack
      direction={direction}
      alignItems={direction === 'row' ? 'center' : 'flex-start'}
      spacing={direction === 'row' ? 1 : '4px'}
      {...props}
    >
      <Typography variant={variant}>{label}</Typography>
      <Box>{value}</Box>
    </Stack>
  );
}
